import { toast, Slide } from "react-toastify";

export function displayAlert(type, title, message) {
  const Msg = ({ title, message }) => (
    <div>
      {title} <br />
      <small>{message}</small>
    </div>
  );
  switch (type) {
    case "success":
      toast.success(<Msg title={title} message={message} />, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        transition: Slide,
      });
      break;

    case "error":
      toast.error(<Msg title={title} message={message} />, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        transition: Slide,
      });
      break;

    case "warning":
      toast.success(<Msg title={title} message={message} />, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        transition: Slide,
      });
      break;

    default:
      break;
  }
}
